/// <amd-module name="VSS/Features/Directory/components/DirectoryGrid/DirectoryGridConstants" />
import * as DirectoryResources from "VSS/Features/Directory/Resources";
import { ColumnActionsMode, IColumn } from "OfficeFabric/DetailsList";

export namespace DirectoryColumnKeys {
    export const Name = "Name";
}

export namespace DirectoryCSS {
    export const DIRECTORY_ROWITEM = "directory-rowitem";
    export const DIRECTORY_GROUP_SPACER = "directory-group-spacer";
    export const DIRECTORY_COLUMN = "directory-column";
    export const DIRECTORY_COLUMN_HEADER = "directory-column-header";
    export const DIRECTORY_DELETED_FAVORITE_CONTAINER = "directory-deleted-favorite-container";
}

export const DEFAULT_NAME_COLUMN: IColumn = {
    fieldName: DirectoryColumnKeys.Name,
    key: DirectoryColumnKeys.Name,
    name: DirectoryResources.NameColumnHeader,
    minWidth: 400,
    maxWidth: 600,
    headerClassName: DirectoryCSS.DIRECTORY_COLUMN_HEADER,
    className: DirectoryCSS.DIRECTORY_COLUMN,
    isResizable: true,
    columnActionsMode: ColumnActionsMode.disabled
};
